module.exports = __webpack_public_path__ + "img/054.d3d001d9.jpeg";